<button class='dots-container' mat-icon-button [matMenuTriggerFor]="menu">
	<mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #menu="matMenu" >
	<button [disabled]="item.disabledDelete" *ngFor="let item of actions" (click)="clickOnMenuItem(item.label)" mat-menu-item >
		<mat-icon [ngStyle]="item.label === 'Delete' && {'color': '#EF492E'}">{{item.icon}}</mat-icon>
		<span [ngStyle]="item.label === 'Delete' && {'color': '#EF492E'}">{{item.label}}</span>
	</button>
</mat-menu>
